interface Req {
  cookies?: Partial<Record<string, string>>;
  headers?: Record<string, string | string[] | undefined>;
}

/**
 * Extracts a cookie value from a cookie string
 */
export function getCookieValueFromString(
  cookieName: string,
  cookieString: string,
): string | null {
  if (!cookieString) {
    return null;
  }

  const cookies = cookieString.split(";");
  const targetCookie = cookies.find((cookie) =>
    cookie.trim().startsWith(`${cookieName}=`),
  );

  if (!targetCookie) {
    return null;
  }

  return targetCookie.split("=")?.[1]?.trim() || null;
}

/**
 * Parses a string value as JSON, returns the original value if parsing fails
 */
export function parseJson<T>(value: string | null): T | null {
  if (value === null) {
    return null;
  }

  try {
    return JSON.parse(value) as T;
  } catch {
    return value as unknown as T;
  }
}

export function getCookieValue<T>(cookieName: string, req?: Req): T | null {
  // Try to get the cookie from the cookie string (browser or request headers)
  const cookieString =
    typeof window === "undefined"
      ? Array.isArray(req?.headers?.cookie)
        ? req.headers.cookie.join("; ")
        : req?.headers?.cookie
      : document.cookie;

  if (cookieString) {
    const value = getCookieValueFromString(cookieName, cookieString);
    return parseJson<T>(value);
  }

  // Try to get the cookie from request cookies object
  if (req) {
    const cookieValue = req?.cookies?.[cookieName];
    return parseJson<T>(cookieValue || null);
  }

  return null;
}
